function getMinMax(band) {
    stats = band.statistics
    if (typeof stats == 'undefined' || stats === null) {
        return "&rescale=0,2000"
    }
    _min = stats.minimum
    _max = stats.maximum
    return "&rescale=" + (_min).toString() + "," + (_max).toString()
}

function getRescale(asset) {
    classif = asset['classification:classes']
    if (typeof classif != 'undefined' && classif !== null) {
        return ""
    }
    bands = asset['raster:bands']
    if (typeof bands == 'undefined' || bands === null) {
        bands = asset['bands']
    }
    if (typeof bands == 'undefined' || bands === null) {
        return "&rescale=0,2000"
    }
    nBands = bands.length
    if (nBands == 1) {
        return getMinMax(bands[0]) + "&bidx=1"
    }
    if (nBands == 2) {
        return getMinMax(bands[0]) + getMinMax(bands[1]) + getMinMax(bands[1]) + "&bidx=1&bidx=2&bidx=2"
    }
    return getMinMax(bands[0]) + getMinMax(bands[1]) + getMinMax(bands[2]) + "&bidx=1&bidx=2&bidx=3"
  }
  
module.exports = {
    catalogUrl: null,
    catalogTitle: "Theia-Mtp STAC Browser",
    allowExternalAccess: true, // Must be true if catalogUrl is not given
    allowedDomains: [],
    detectLocaleFromBrowser: true,
    storeLocale: true,
    locale: "en",
    fallbackLocale: "en",
    supportedLocales: [
        "de",
//      "de-CH",
        "es",
        "en",
        "fr",
//      "fr-CA",
//      "fr-CH",
        "it",
//      "it-CH",
        "ro"
    ],
    apiCatalogPriority: null,
    useTileLayerAsFallback: false,
    tileSourceTemplate: null,
    displayGeoTiffByDefault: false,
    buildTileUrlTemplate: ({href, asset}) => "https://wmts.stac.teledetection.fr/cog/tiles/WebMercatorQuad/{z}/{x}/{y}@2x?url=" + encodeURIComponent(asset.href) + getRescale(asset),
    stacProxyUrl: null,
    pathPrefix: "/",
    historyMode: "history",
    cardViewMode: "cards",
    cardViewSort: "asc",
    showThumbnailsAsAssets: false,
    stacLint: true,
    geoTiffResolution: 128,
    redirectLegacyUrls: false,
    itemsPerPage: 12,
    defaultThumbnailSize: null,
    maxPreviewsOnMap: 50,
    crossOriginMedia: null,
    requestHeaders: {},
    requestQueryParameters: {},
    preprocessSTAC: null,
    authConfig: null
};